import { render, staticRenderFns } from "./cambiarOrdenOficios.vue?vue&type=template&id=7bf27575"
import script from "./cambiarOrdenOficios.vue?vue&type=script&lang=js"
export * from "./cambiarOrdenOficios.vue?vue&type=script&lang=js"
import style0 from "./cambiarOrdenOficios.vue?vue&type=style&index=0&id=7bf27575&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports